const questionMapping = {
  age: 'HRA-DQ-01',
  genderIdentity: 'HRA-DQ-03',
  diagnoses: 'HRA-MH-44',
  previousAntiObesityMedications: 'HRA-WH-09',
  previousBariatricSurgeries: 'HRA-MH-02',
  whichPreviousBariatricSurgeries: 'HRA-MH-02-a',
  historyOfEatingDisorder: 'HRA-MH-03',
  activeEatingDisorder: 'HRA-MH-03-a',
  workingWithMentalHealthProfessional: 'HRA-MH-03-b',
  biggestMealOfTheDay: 'HRA-EP-03',
  typicalBreakfast: 'HRA-EP-01',
  weeklyRestaurantMeals: 'HRA-EP-05',
  foodAllergiesSensitivities: 'HRA-WH-11-a',
  weeklySugarSweetenedBeverages: 'HRA-EP-02',
  middleOfTheNightEating: 'HRA-EP-04',
  cravings: 'HRA-FC-02',
  excessiveAppetite: 'HRA-FC-03',
  grazing: 'HRA-FC-04',
  triggerForOvereating: 'HRA-FC-01',
  activityLevel: 'HRA-LS-03',
  typeOfActivity: 'HRA-LS-04-a',
  independentWithADLs: 'HRA-LS-01',
  ambulatory: 'HRA-LS-02',
  osaDiagnosis: 'HRA-MH-34',
  osaTreatment: 'HRA-MH-35',
  ohsDiagnosis: 'HRA-MH-36',
  ohsTreatment: 'HRA-MH-37',
  insomnia: 'HRA-MH-38',
  currentLifestyleFactors: 'HRA-LS-08',
  hoursOfSleepPerNight: 'HRA-MH-40',
  snoring: 'HRA-MH-41',
  witnessedApnea: 'HRA-MH-42',
  daytimeSleepiness: 'HRA-MH-43',
  alcohol: 'HRA-LS-12',
  nicotineTobacco: 'HRA-LS-16',
  recreationalDrugs: 'HRA-LS-28',
  historyOfDrugAbuse: 'HRA-LS-29',
  biologicalMother: 'HRA-WH-14',
  biologicalFather: 'HRA-WH-16',
  biologicalSiblings: 'HRA-WH-18',
  allergies: 'HRA-WH-10-a',
  foodAllergies: 'HRA-WH-11-a',
  medications: 'HRA-WH-08',
  sleepMedications: 'HRA-MH-39',
  weightGainEvents: 'HRA-WH-04',
  lowestAdultWeight: 'HRA-WH-01',
  motivationForWeightLoss: 'HRA-WH-05',
  challenges: 'HRA-WH-07',
  occupation: 'HRA-LS-08',
  occupationContributorsToWeight: 'HRA-LS-08',
  maritalStatus: 'HRA-LS-09',
  children: 'HRA-LS-10',
  howManyChildren: 'HRA-LS-11',
  pregnancyStatus: 'HRA-WH-12',
  contraception: 'HRA-WH-12b',
  pastSurgeries: 'HRA-WH-13-a',
  familyHistoryMother: 'HRA-WH-14',
  familyHistoryFather: 'HRA-WH-16',
  familyHistorySiblings: 'HRA-WH-18',
  phq8: 'HRA-MH-17',
  scoff: 'HRA-SC-01',
  bed2: 'HRA-SC-03',
  bddqAs: 'HRA-BD-01',
  iwqol: 'HRA-IWQOL-01',
};

module.exports = questionMapping;
